import { Button, Input, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

import { getUserId } from '../../helpers/auth'
import {
  useCreateDomainCategoryMutation,
  useUpdateDomainCategoryByIdMutation
} from '../../redux/apis/domainsManagement/category/dMDomainsCategoryApiSlice'
import Loader from '../../pages/pages/loader'

const EditCreateDomainCategoriesModal = ({
  category,
  open,
  setOpen,
  isEdit = false,
  setHolder,
  setIsEdit,
  canCreate = true
}) => {
  const [create, { isLoading, isSuccess, error }] =
    useCreateDomainCategoryMutation()
  const [
    update,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError }
  ] = useUpdateDomainCategoryByIdMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      domain_category: category?.domain_category || '',
      category_status: isEdit
        ? category?.category_status
          ? true
          : false
        : true,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      domain_category: Yup.string().required('Please Enter Campaign Keyword '),
      category_status: Yup.boolean().required('Please Select Campaign Status')
    }),

    onSubmit: async values => {
      try {
        if (isEdit) {
          await update({ id: category?.id, body: values }).unwrap()
        } else {
          await create(values)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (updateError?.data) {
      const errorMessages = Object.values(updateError.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error, updateError])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Domain category Added!')
      setOpen(false)
      validation.resetForm()
    } else if (updateSuccess) {
      toast.success('Domain category Updated!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess, updateSuccess])
  return (
    <>
      <Loader isLoading={isLoading || updateLoading} />
      <div className='flex w-full justify-end '>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setHolder()
            setIsEdit(false)
            setOpen(true)
          }}
        >
          Create New Domain Category
        </button>
      </div>
      <Modal
        open={open}
        title={isEdit ? 'Edit Domain Category' : 'Create New Domain Category'}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key])
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Domain Category Name</label>
            <Input
              type='text'
              name='domain_category'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.domain_category}
            />
            {validation.touched.domain_category &&
            validation.errors.domain_category ? (
              <p className='text-danger'>{validation.errors.domain_category}</p>
            ) : null}
          </div>

          <div className=' mb-3 flex-1'>
            <label>Category Status</label>
            <br />
            <Select
              className={''}
              name='category_status'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.category_status}
              value={validation?.values?.category_status}
              onChange={e => validation.setFieldValue('category_status', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.status && validation.errors.status ? (
              <p className='text-danger'>{validation.errors.status}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditCreateDomainCategoriesModal
